import { getReactProps } from '@m2h/common/utils/styleUtils';

export default class MachproHTMLElement extends HTMLElement {
  isProcessingStyle = false; // 防重入标志
  lastStyleValue = ''; // 记录上次的 style 值

  constructor() {
    super();
  }

  handleClick(event) {
    const reactProps = getReactProps(this);
    if (reactProps) {
      if (reactProps.onClick) {
        event.stopPropagation();
        reactProps.onClick(event);
      }
    }
    // console.log(123);
    // event.stopPropagation();
  }

  measure() {
    // 获取元素的边界矩形
    const rect = this.getBoundingClientRect();

    // 获取父元素的边界矩形
    const parent = this.parentElement;
    if (!parent) return;
    const parentRect = parent.getBoundingClientRect();

    // 计算相对父元素的坐标
    const x = rect.left - parentRect.left;
    const y = rect.top - parentRect.top;

    // 获取元素的宽度和高度
    const width = rect.width;
    const height = rect.height;

    // 返回结果
    return {
      x,
      y,
      width,
      height,
    };
  }

  measureInWindow() {
    const rect = this.getBoundingClientRect();
    return {
      y: rect.top + window.scrollY,
      x: rect.left + window.scrollX,
      width: rect.width,
      height: rect.height,
    };
  }

  measureInView(target) {
    if (!target) return null;
    const rect = this.getBoundingClientRect();
    const targetRect = target?.getBoundingClientRect() || {
      top: 0,
      left: 0,
    };
    // 获取计算后的样式
    const computedStyle = window.getComputedStyle(target);
    const padding = {
      top: parseFloat(computedStyle.paddingTop),
      right: parseFloat(computedStyle.paddingRight),
      bottom: parseFloat(computedStyle.paddingBottom),
      left: parseFloat(computedStyle.paddingLeft)
    };
    return {
      y: rect.top - targetRect.top - padding.top,
      x: rect.left - targetRect.left,
      width: rect.width,
      height: rect.height,
    };
  }

  connectedCallback() {
    // // RTL 适配
    // const computedStyle = window.getComputedStyle(this);
    // if (computedStyle.textAlign === 'left') {
    //   this.style.textAlign = 'start';
    // }
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    // 基类的清理逻辑（如果需要的话）
    this.removeEventListener('click', this.handleClick);
  }

  // className属性打包时处理为class，运行时需要在属性变化后同步到webcomponent
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'className' || name === 'classname') {
      this.className = newValue;
    }
  }

  static get observedAttributes() {
    return ['className', 'classname'];
  }
}
